import React from 'react';
import '../../../styles.css';
import simg from '../../../assets/real_letters/s.jpg';
import mimg from '../../../assets/real_letters/m.jpg';
import timg from '../../../assets/real_letters/t.jpg';
import pimg from '../../../assets/real_letters/p.jpg';
import nimg from '../../../assets/real_letters/n.jpg';
import cimg from '../../../assets/real_letters/c.jpg';
import kimg from '../../../assets/real_letters/k.jpg';
import rimg from '../../../assets/real_letters/r.jpg';
import bimg from '../../../assets/real_letters/b.jpg';
import jimg from '../../../assets/real_letters/j.jpg';
import fimg from '../../../assets/real_letters/f.jpg';
import gimg from '../../../assets/real_letters/g.jpg';
import himg from '../../../assets/real_letters/h.jpg';
import dimg from '../../../assets/real_letters/d.jpg';
import wimg from '../../../assets/real_letters/w.jpg';
import vimg from '../../../assets/real_letters/v.jpg';
import limg from '../../../assets/real_letters/l.jpg';
import yimg from '../../../assets/real_letters/y.jpg';

const letterImages = {
    's': simg,
    'm': mimg,
    't': timg,
    'p': pimg,
    'n': nimg,
    'c': cimg,
    'k': kimg,
    'r': rimg,
    'b': bimg,
    'j': jimg,
    'f': fimg,
    'g': gimg,
    'h': himg,
    'd': dimg,
    'w': wimg,
    'v': vimg,
    'l': limg,
    'y': yimg
}

function LetterAnswerButton(props) {
    if (props.submitState === 0) {
        props.setCorrectDialogue()
        if (props.currentlyClicked === props.id) {
            return(
                <button className={'selectedAnswerButton'}>
                    <img className='photographsInDivs' onClick={() => props.stateChanger(props.id)} src={letterImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else {
            return (
                <button className={'answerButton'}>
                    <img className='photographsInDivs' onClick={() => props.stateChanger(props.id)} src={letterImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            );        
        }
    } else if (props.submitState === 1) {
        if (props.correctLetter === (props.id-1)) {
            return (
                <button className={'selectedAnswerButton'} style={{borderColor:'#04cc00'}}>
                    <img className='photographsInDivs' src={letterImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else if (props.currentlyClicked === props.id) {
            props.setIncorrectDialogue()
            return (
                <button className={'selectedAnswerButton'} style={{borderColor:'#ff000f'}}>
                    <img className='photographsInDivs' src={letterImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else {
            return (
                <button className={'answerButton'}>
                    <img className='photographsInDivs' src={letterImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            ) 
        }
    }
}

export default LetterAnswerButton;